<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header> Select box.. </template>
      <template v-slot:default="props">
        <v-row>
          <v-col v-for="(item, i) in props.items" :key="i" cols="12">
            <v-card >
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <!-- <v-card-title class="subheading font-weight-bold">{{item.Event}}</v-card-title> -->
                  <v-card-title>
                    <v-btn
                      color="primary"
                      min-width="300"
                      :class="`d-flex justify-space-around mb-4`"
                      @click="selectedEvent(item)"
                      :outlined="item.Outlined"
                      :disabled="item.Disable"
                    >
                      {{ item.Event }}
                      <v-icon right :color="item.Color" v-if="item.RegId > 0"> mdi-check-circle</v-icon>
                      <div v-if="item.Outlined">
                        <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                      </div>
                    </v-btn>
                  </v-card-title>
                  <v-card-subtitle style="color: blue">{{
                    item.Comment
                  }}</v-card-subtitle>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- <template v-slot:footer>
      </template> -->
    </v-data-iterator>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "OpenedEventList",
  props: {
    regId: {
      type: String,
    },
  },
  data() {
    return {
      itemsPerPageArray: [10, 20, 40, 100],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 100,
      sortBy: "Event",
      keys: ["EventId", "Event", "Comment", "Outlined", "Id"],
      items: [],
    };
  },
  created() {
    axios
      // .get("http://jsonplaceholder.typicode.com/posts")
      // HUSK baseUrl ON DEPLOY
      // .get("http://localhost:3000/dbapi/getOpenedEvents/" + this.regId)
      .get("https://pgapi.azurewebsites.net/dbapi/getOpenedEvents/" + this.regId)
      .then((response) => {
        // JSON responses are automatically parsed.
        this.items = response.data;
        // console.log(this.items);
        this.loading = false;
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== `Name`);
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    selectedEvent(item) {
      this.$emit("selected-eventid", item.EventId);
      var array = this.items;
      array.forEach((element) => {
        element.Outlined = false;
      });
      this.items[item.Id - 1].Outlined = true;
      // console.log(this.items);
    },
  },
};
</script>